import moment from "moment";
import { Field } from "./field";
import { OrderedMap, Record } from "immutable";

const defaults = {
    _id: undefined,
    created_on: undefined,
    modified_on: undefined,
    name: "",
    fields: OrderedMap,
};

interface IField {
    _id: string;
    key: string;
}

export class MasterSchemaRecord extends Record(defaults) {
    declare _id: string;
    declare name: string;
    declare created_on: moment.Moment;
    declare modified_on: moment.Moment;
    declare fields: OrderedMap<string, IField>;

    constructor(args: any = {}) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            fields: OrderedMap(
                args.fields &&
                    args.fields.map((val) => {
                        return [val.key, new Field(val)];
                    }),
            ),
            modified_on: moment.utc(args.modified_on),
        });
    }

    toJS() {
        const js = super.toJS();
        js.fields = Object.keys(js.fields).map((key) => js.fields[key]);
        Object.keys(js).forEach((key) => {
            if (typeof js[key] === "undefined") {
                delete js[key];
            }
        });
        return js;
    }
}
